import { render, staticRenderFns } from "./BulkTag.vue?vue&type=template&id=1dfc9727"
import script from "./BulkTag.vue?vue&type=script&lang=js"
export * from "./BulkTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports